// AUTOMATICALLY GENERATED BY scripts/build-exports.ts. Do not edit by hand!

import JdsActionBox from '@/design-system/patterns/JdsActionBox.vue'
import JdsAnalyticsProvider from '@/design-system/foundation/AnalyticsProvider/JdsAnalyticsProvider.vue'
import JdsArticle from '@/design-system/components/Article/JdsArticle.vue'
import JdsAttributeListLayout from '@/design-system/constructs/AttributeSticker/JdsAttributeListLayout.vue'
import JdsAttributeSticker from '@/design-system/constructs/AttributeSticker/JdsAttributeSticker.vue'
import JdsAvatarStack from '@/design-system/constructs/Avatar/JdsAvatarStack.vue'
import JdsBreakdown from '@/design-system/patterns/Breakdown/JdsBreakdown.vue'
import JdsBreakdownHeading from '@/design-system/patterns/Breakdown/JdsBreakdownHeading.vue'
import JdsBreakdownItem from '@/design-system/patterns/Breakdown/JdsBreakdownItem.vue'
import JdsButton from '@/design-system/components/Button/JdsButton.vue'
import JdsCallout from '@/design-system/components/Callout/JdsCallout.vue'
import JdsCandidateBubble from '@/design-system/constructs/CandidateBubble/JdsCandidateBubble.vue'
import JdsCheckbox from '@/design-system/forms/fields/JdsCheckbox.vue'
import JdsCheckboxGroup from '@/design-system/forms/fields/JdsCheckboxGroup.vue'
import JdsColorPicker from '@/design-system/forms/fields/ColorPicker/JdsColorPicker.vue'
import JdsConfirmation from '@/design-system/patterns/Confirmation/JdsConfirmation.vue'
import JdsDatum from '@/design-system/components/Datum/JdsDatum.vue'
import JdsDialog from '@/design-system/patterns/Dialog/JdsDialog.vue'
import JdsDraftingTable from '@/design-system/patterns/DraftingTable/JdsDraftingTable.vue'
import JdsDropdownMenu from '@/design-system/patterns/DropdownMenu/JdsDropdownMenu.vue'
import JdsDropdownMenuItem from '@/design-system/patterns/DropdownMenu/JdsDropdownMenuItem.vue'
import JdsEcho from '@/design-system/forms/JdsEcho.vue'
import JdsEntrySlot from '@/design-system/components/JdsEntrySlot.vue'
import JdsExplorer from '@/design-system/patterns/Explorer/JdsExplorer.vue'
import JdsFieldGroup from '@/design-system/forms/fields/JdsFieldGroup.vue'
import JdsFieldLayout from '@/design-system/components/Field/JdsFieldLayout.vue'
import JdsFieldRow from '@/design-system/forms/fields/JdsFieldRow.vue'
import JdsFilterBar from '@/design-system/forms/filters/JdsFilterBar.vue'
import JdsForm from '@/design-system/forms/JdsForm.vue'
import JdsGlyph from '@/design-system/icons/JdsGlyph.vue'
import JdsIcon from '@/design-system/icons/JdsIcon.vue'
import JdsInlineTextField from '@/design-system/forms/fields/JdsInlineTextField.vue'
import JdsInspector from '@/design-system/patterns/Inspector/JdsInspector.vue'
import JdsJobTile from '@/design-system/constructs/JobTile/JdsJobTile.vue'
import JdsJobTileListLayout from '@/design-system/constructs/JobTile/JdsJobTileListLayout.vue'
import JdsLink from '@/design-system/components/Link/JdsLink.vue'
import JdsListFilter from '@/design-system/forms/filters/JdsListFilter.vue'
import JdsLoader from '@/design-system/foundation/JdsLoader.vue'
import JdsLocaleProvider from '@/design-system/foundation/JdsLocaleProvider.vue'
import JdsMeridian from '@/design-system/patterns/Meridian/JdsMeridian.vue'
import JdsMeridianBadge from '@/design-system/patterns/Meridian/JdsMeridianBadge.vue'
import JdsMeridianItem from '@/design-system/patterns/Meridian/JdsMeridianItem.vue'
import JdsMeridianLayout from '@/design-system/patterns/Meridian/JdsMeridianLayout.vue'
import JdsMoney from '@/design-system/components/Money/JdsMoney.vue'
import JdsMonitorProvider from '@/design-system/foundation/JdsMonitorProvider.vue'
import JdsNametag from '@/design-system/constructs/Nametag/JdsNametag.vue'
import JdsNavigator from '@/design-system/patterns/Navigator/JdsNavigator.vue'
import JdsNavigatorBackLink from '@/design-system/patterns/Navigator/JdsNavigatorBackLink.vue'
import JdsNavigatorBadge from '@/design-system/patterns/Navigator/JdsNavigatorBadge.vue'
import JdsNavigatorChildItem from '@/design-system/patterns/Navigator/JdsNavigatorChildItem.vue'
import JdsNavigatorFullPageLayout from '@/design-system/patterns/Navigator/JdsNavigatorFullPageLayout.vue'
import JdsNavigatorHeading from '@/design-system/patterns/Navigator/JdsNavigatorHeading.vue'
import JdsNavigatorItem from '@/design-system/patterns/Navigator/JdsNavigatorItem.vue'
import JdsNavigatorItemGroup from '@/design-system/patterns/Navigator/JdsNavigatorItemGroup.vue'
import JdsNotificationBadge from '@/design-system/constructs/NotificationBadge/JdsNotificationBadge.vue'
import JdsPageBackLink from '@/design-system/patterns/Page/JdsPageBackLink.vue'
import JdsPageIntro from '@/design-system/patterns/Page/JdsPageIntro.vue'
import JdsPageLayout from '@/design-system/patterns/Page/JdsPageLayout.vue'
import JdsPageSection from '@/design-system/patterns/Page/JdsPageSection.vue'
import JdsPageSectionHeading from '@/design-system/patterns/Page/JdsPageSectionHeading.vue'
import JdsPageTitle from '@/design-system/patterns/Page/JdsPageTitle.vue'
import JdsPaginator from '@/design-system/components/Paginator/JdsPaginator.vue'
import JdsPipeline from '@/design-system/patterns/Pipeline/JdsPipeline.vue'
import JdsPipelineBucket from '@/design-system/patterns/Pipeline/JdsPipelineBucket.vue'
import JdsPipelineCard from '@/design-system/patterns/Pipeline/JdsPipelineCard.vue'
import JdsPipelineCardDrawer from '@/design-system/patterns/Pipeline/JdsPipelineCardDrawer.vue'
import JdsPipelineDrawer from '@/design-system/patterns/Pipeline/JdsPipelineDrawer.vue'
import JdsPipelineStage from '@/design-system/patterns/Pipeline/JdsPipelineStage.vue'
import JdsPipelineStageBadge from '@/design-system/patterns/Pipeline/JdsPipelineStageBadge.vue'
import JdsReaction from '@/design-system/components/ReactionPanel/JdsReaction.vue'
import JdsReactionBadge from '@/design-system/constructs/NotificationBadge/JdsReactionBadge.vue'
import JdsReactionOption from '@/design-system/components/ReactionPanel/JdsReactionOption.vue'
import JdsReactionPanel from '@/design-system/components/ReactionPanel/JdsReactionPanel.vue'
import JdsRichRadioGroup from '@/design-system/forms/fields/JdsRichRadioGroup.vue'
import JdsRichRadioOption from '@/design-system/forms/fields/JdsRichRadioOption.vue'
import JdsScoreBadge from '@/design-system/constructs/ScoreBadge/JdsScoreBadge.vue'
import JdsSelectField from '@/design-system/forms/fields/JdsSelectField.vue'
import JdsSelectFieldOption from '@/design-system/forms/fields/JdsSelectFieldOption.vue'
import JdsSheet from '@/design-system/patterns/Sheet/JdsSheet.vue'
import JdsSpotlight from '@/design-system/patterns/Spotlight/JdsSpotlight.vue'
import JdsTable from '@/design-system/patterns/Table/JdsTable.vue'
import JdsTableBadge from '@/design-system/patterns/Table/JdsTableBadge.vue'
import JdsTableCell from '@/design-system/patterns/Table/JdsTableCell.vue'
import JdsTableCurrencyCell from '@/design-system/patterns/Table/JdsTableCurrencyCell.vue'
import JdsTableCurrencyFooter from '@/design-system/patterns/Table/JdsTableCurrencyFooter.vue'
import JdsTableFooterCutout from '@/design-system/patterns/Table/JdsTableFooterCutout.vue'
import JdsTableFooterRow from '@/design-system/patterns/Table/JdsTableFooterRow.vue'
import JdsTableHeading from '@/design-system/patterns/Table/JdsTableHeading.vue'
import JdsTableRow from '@/design-system/patterns/Table/JdsTableRow.vue'
import JdsTableSegment from '@/design-system/patterns/Table/JdsTableSegment.vue'
import JdsTableToolbarCell from '@/design-system/patterns/Table/JdsTableToolbarCell.vue'
import JdsTeleportProvider from '@/design-system/foundation/JdsTeleportProvider.vue'
import JdsTerminology from '@/design-system/components/JdsTerminology.vue'
import JdsTextAreaField from '@/design-system/forms/fields/JdsTextAreaField.vue'
import JdsTextField from '@/design-system/forms/fields/JdsTextField.vue'
import JdsTextProvider from '@/design-system/foundation/JdsTextProvider.vue'
import JdsTimeline from '@/design-system/components/Timeline/JdsTimeline.vue'
import JdsTimelineItem from '@/design-system/components/Timeline/JdsTimelineItem.vue'
import JdsTimestamp from '@/design-system/components/Timestamp/JdsTimestamp.vue'
import JdsToolbar from '@/design-system/patterns/JdsToolbar.vue'
import JdsWorkbench from '@/design-system/patterns/Workbench/JdsWorkbench.vue'
import JdsWorkbenchBackButton from '@/design-system/patterns/Workbench/JdsWorkbenchBackButton.vue'
import JdsWorkbenchHeader from '@/design-system/patterns/Workbench/JdsWorkbenchHeader.vue'
import JdsWorkbenchToolbar from '@/design-system/patterns/Workbench/JdsWorkbenchToolbar.vue'

import {installJdsValidation} from "@/design-system/forms/ValidationService"

const JobillaDesignSystem: any = {}

import '@/assets/styles/index.css';
import { JdsError } from "./design-system/utilities/JdsError";

JobillaDesignSystem.install = function (Vue: any) {
    // System setup
    installJdsValidation()

    Vue.component('JdsActionBox', JdsActionBox)
Vue.component('JdsAnalyticsProvider', JdsAnalyticsProvider)
Vue.component('JdsArticle', JdsArticle)
Vue.component('JdsAttributeListLayout', JdsAttributeListLayout)
Vue.component('JdsAttributeSticker', JdsAttributeSticker)
Vue.component('JdsAvatarStack', JdsAvatarStack)
Vue.component('JdsBreakdown', JdsBreakdown)
Vue.component('JdsBreakdownHeading', JdsBreakdownHeading)
Vue.component('JdsBreakdownItem', JdsBreakdownItem)
Vue.component('JdsButton', JdsButton)
Vue.component('JdsCallout', JdsCallout)
Vue.component('JdsCandidateBubble', JdsCandidateBubble)
Vue.component('JdsCheckbox', JdsCheckbox)
Vue.component('JdsCheckboxGroup', JdsCheckboxGroup)
Vue.component('JdsColorPicker', JdsColorPicker)
Vue.component('JdsConfirmation', JdsConfirmation)
Vue.component('JdsDatum', JdsDatum)
Vue.component('JdsDialog', JdsDialog)
Vue.component('JdsDraftingTable', JdsDraftingTable)
Vue.component('JdsDropdownMenu', JdsDropdownMenu)
Vue.component('JdsDropdownMenuItem', JdsDropdownMenuItem)
Vue.component('JdsEcho', JdsEcho)
Vue.component('JdsEntrySlot', JdsEntrySlot)
Vue.component('JdsExplorer', JdsExplorer)
Vue.component('JdsFieldGroup', JdsFieldGroup)
Vue.component('JdsFieldLayout', JdsFieldLayout)
Vue.component('JdsFieldRow', JdsFieldRow)
Vue.component('JdsFilterBar', JdsFilterBar)
Vue.component('JdsForm', JdsForm)
Vue.component('JdsGlyph', JdsGlyph)
Vue.component('JdsIcon', JdsIcon)
Vue.component('JdsInlineTextField', JdsInlineTextField)
Vue.component('JdsInspector', JdsInspector)
Vue.component('JdsJobTile', JdsJobTile)
Vue.component('JdsJobTileListLayout', JdsJobTileListLayout)
Vue.component('JdsLink', JdsLink)
Vue.component('JdsListFilter', JdsListFilter)
Vue.component('JdsLoader', JdsLoader)
Vue.component('JdsLocaleProvider', JdsLocaleProvider)
Vue.component('JdsMeridian', JdsMeridian)
Vue.component('JdsMeridianBadge', JdsMeridianBadge)
Vue.component('JdsMeridianItem', JdsMeridianItem)
Vue.component('JdsMeridianLayout', JdsMeridianLayout)
Vue.component('JdsMoney', JdsMoney)
Vue.component('JdsMonitorProvider', JdsMonitorProvider)
Vue.component('JdsNametag', JdsNametag)
Vue.component('JdsNavigator', JdsNavigator)
Vue.component('JdsNavigatorBackLink', JdsNavigatorBackLink)
Vue.component('JdsNavigatorBadge', JdsNavigatorBadge)
Vue.component('JdsNavigatorChildItem', JdsNavigatorChildItem)
Vue.component('JdsNavigatorFullPageLayout', JdsNavigatorFullPageLayout)
Vue.component('JdsNavigatorHeading', JdsNavigatorHeading)
Vue.component('JdsNavigatorItem', JdsNavigatorItem)
Vue.component('JdsNavigatorItemGroup', JdsNavigatorItemGroup)
Vue.component('JdsNotificationBadge', JdsNotificationBadge)
Vue.component('JdsPageBackLink', JdsPageBackLink)
Vue.component('JdsPageIntro', JdsPageIntro)
Vue.component('JdsPageLayout', JdsPageLayout)
Vue.component('JdsPageSection', JdsPageSection)
Vue.component('JdsPageSectionHeading', JdsPageSectionHeading)
Vue.component('JdsPageTitle', JdsPageTitle)
Vue.component('JdsPaginator', JdsPaginator)
Vue.component('JdsPipeline', JdsPipeline)
Vue.component('JdsPipelineBucket', JdsPipelineBucket)
Vue.component('JdsPipelineCard', JdsPipelineCard)
Vue.component('JdsPipelineCardDrawer', JdsPipelineCardDrawer)
Vue.component('JdsPipelineDrawer', JdsPipelineDrawer)
Vue.component('JdsPipelineStage', JdsPipelineStage)
Vue.component('JdsPipelineStageBadge', JdsPipelineStageBadge)
Vue.component('JdsReaction', JdsReaction)
Vue.component('JdsReactionBadge', JdsReactionBadge)
Vue.component('JdsReactionOption', JdsReactionOption)
Vue.component('JdsReactionPanel', JdsReactionPanel)
Vue.component('JdsRichRadioGroup', JdsRichRadioGroup)
Vue.component('JdsRichRadioOption', JdsRichRadioOption)
Vue.component('JdsScoreBadge', JdsScoreBadge)
Vue.component('JdsSelectField', JdsSelectField)
Vue.component('JdsSelectFieldOption', JdsSelectFieldOption)
Vue.component('JdsSheet', JdsSheet)
Vue.component('JdsSpotlight', JdsSpotlight)
Vue.component('JdsTable', JdsTable)
Vue.component('JdsTableBadge', JdsTableBadge)
Vue.component('JdsTableCell', JdsTableCell)
Vue.component('JdsTableCurrencyCell', JdsTableCurrencyCell)
Vue.component('JdsTableCurrencyFooter', JdsTableCurrencyFooter)
Vue.component('JdsTableFooterCutout', JdsTableFooterCutout)
Vue.component('JdsTableFooterRow', JdsTableFooterRow)
Vue.component('JdsTableHeading', JdsTableHeading)
Vue.component('JdsTableRow', JdsTableRow)
Vue.component('JdsTableSegment', JdsTableSegment)
Vue.component('JdsTableToolbarCell', JdsTableToolbarCell)
Vue.component('JdsTeleportProvider', JdsTeleportProvider)
Vue.component('JdsTerminology', JdsTerminology)
Vue.component('JdsTextAreaField', JdsTextAreaField)
Vue.component('JdsTextField', JdsTextField)
Vue.component('JdsTextProvider', JdsTextProvider)
Vue.component('JdsTimeline', JdsTimeline)
Vue.component('JdsTimelineItem', JdsTimelineItem)
Vue.component('JdsTimestamp', JdsTimestamp)
Vue.component('JdsToolbar', JdsToolbar)
Vue.component('JdsWorkbench', JdsWorkbench)
Vue.component('JdsWorkbenchBackButton', JdsWorkbenchBackButton)
Vue.component('JdsWorkbenchHeader', JdsWorkbenchHeader)
Vue.component('JdsWorkbenchToolbar', JdsWorkbenchToolbar)
}

const Candidate: any = {}

export { JobillaDesignSystem,
    Candidate,
    JdsError,
JdsConfirmation,
JdsDialog,
JdsExplorer,
JdsInspector,
JdsNametag,
JdsNavigatorFullPageLayout,
}

